import { render } from "./Quotations1.vue?vue&type=template&id=5729068b"
import script from "./Quotations1.vue?vue&type=script&lang=js"
export * from "./Quotations1.vue?vue&type=script&lang=js"
script.render = render

export default script